import React from "react";
import { isMobile } from "react-device-detect";
import {
  useBottomNavigator,
  useTelegramSafeAreaInsets,
} from "utils/hooks/misc";
import styled, { useTheme } from "styled-components";
import { IS_TELEGRAM_WEB_APP } from "common/constants";
import { Inset } from "@shared/types";
import { CornixDashboardLogo } from "common/Icons/Icons.tsx";

const TelegramAppHeader = () => {
  const theme = useTheme();
  const bottomNavigatorData = useBottomNavigator();
  const { safeAreaInset, contentSafeAreaInset } = useTelegramSafeAreaInsets();

  if (
    !IS_TELEGRAM_WEB_APP ||
    !bottomNavigatorData.baseShouldDisplay ||
    !isMobile
  )
    return null;

  return (
    <div>
      {!!safeAreaInset?.top && (
        <StatusBarPlaceholder $safeAreaInset={safeAreaInset} />
      )}
      <InnerWrapper $contentSafeAreaInset={contentSafeAreaInset}>
        <CornixDashboardLogo
          primaryColor={theme.colors.primaryGrey}
          secondaryColor={theme.colors.primaryBlue}
          style={{ height: 20 }}
        />
      </InnerWrapper>
    </div>
  );
};

export default TelegramAppHeader;

const StatusBarPlaceholder = styled.div<{
  $safeAreaInset?: Inset;
}>`
  background-color: black;
  height: ${(p) => p.$safeAreaInset?.top || 0}px !important;
`;
const InnerWrapper = styled.div<{
  $contentSafeAreaInset?: Inset;
}>`
  background-color: ${(p) => p.theme.colors.bgColor};
  height: ${(p) => p.$contentSafeAreaInset?.top || 0}px !important;
  display: flex;
  align-items: center;
  justify-content: center;
`;
